<nav
  class="{{
    collapsed ? 'tw-w-14' : 'tw-w-[250px] lg:tw-w-[300px]'
  }}  tw-h-screen tw-bg-white tw-flex-col tw-justify-start tw-items-start tw-inline-flex tw-transition-all tw-duration-500  tw-ease-in-out tw-shadow-xl {{
    sideNavHidden
      ? 'tw-overflow-hidden !tw-w-0 lg:!tw-w-[300px]'
      : '!tw-w-[250px] lg:!tw-w-14'
  }}"
  id="sideNav"
>
  <div class="tw-flex tw-w-full tw-bg-slate-100 tw-justify-between tw-py-1">
    <div
      class="tw-self-stretch tw-h-[87px] tw-py-4 {{
        collapsed ? 'tw-px-2' : 'tw-px-6'
      }} tw-justify-between tw-items-center tw-inline-flex"
    >
      <img
        class="tw-h-[30px] tw-w-[50px] lg:tw-w-[132px]"
        [src]="
          collapsed
            ? '/assets/logos/logo-small-black.svg'
            : '/assets/logos/logo-black.svg'
        "
        alt="Logo"
      />
    </div>
    <cohrex-button
      color="primaryLink"
      class="tw-justify-center tw-items-center tw-flex tw-mr-3 tw-visible lg:tw-hidden"
      (click)="handleHideSideNavOnMobile($event)"
      id="hideSideNav"
    >
      <div
        class="tw-w-3 tw-h-3 tw-px-[3px] tw-rounded tw-justify-center tw-items-center tw-flex tw-cursor-pointer"
      >
        <div class="material-icons">keyboard_arrow_left</div>
      </div>
    </cohrex-button>
  </div>

  <div
    class=" {{
      collapsed ? 'tw-px-0' : 'tw-px-0'
    }} tw-self-stretch tw-grow tw-shrink tw-basis-0 tw-px-0 tw-py-6 tw-flex-col tw-justify-start tw-items-start tw-gap-4 tw-flex"
  >
    @for (menu of menus; track menu) {
      @if (!menu.children) {
        @if (
          (menu.isCompanyManagement && activeCustomer) ||
          !menu.isCompanyManagement
        ) {
          <a
            [routerLink]="[menu.path]"
            class="tw-h-10 tw-py-2 tw-rounded-lg tw-justify-start tw-items-center tw-gap-2 tw-inline-flex hover:tw-opacity-90 tw-text-neutral-800 tw-cursor-pointer tw-px-3 tw-w-full"
            routerLinkActive="tw-bg-blue-800 !tw-text-white tw-rounded-none"
            (click)="hideAllChildrenMenu()"
          >
            <div
              class="tw-w-6 tw-h-6 tw-p-[2.22px] tw-justify-center tw-items-center tw-flex"
            >
              <cohrex-svg
                [name]="menu.icon"
                routerLinkActive="fill-white"
              ></cohrex-svg>
            </div>
            <div
              class="tw-grow tw-shrink tw-basis-0  {{
                !sideNavHidden ? 'tw-block' : 'tw-hidden'
              }} {{ collapsed ? 'lg:tw-hidden' : 'lg:tw-block' }}"
            >
              {{ menu.title | translate }}
            </div>
          </a>
        }
      } @else {
        @if (
          (menu.isCompanyManagement && activeCustomer) ||
          !menu.isCompanyManagement
        ) {
          <div class="tw-w-full tw-h-min">
            <button
              (click)="handleParentMenuClick($event)"
              class="tw-flex tw-justify-between tw-items-center tw-w-full tw-py-3 tw-text-neutral-800 tw-rounded-lg tw-rounded-b-none tw-px-3"
              [ngClass]="[
                isParentMenuActive(menu.children)
                  ? 'tw-bg-blue-800 tw-text-white tw-rounded-none'
                  : 'tw-h-0 tw-overflow-hidden tw-my-2'
              ]"
            >
              <div
                class="tw-rounded-lg tw-justify-start tw-items-center tw-gap-2 tw-inline-flex hover:tw-opacity-90 tw-cursor-pointer"
              >
                <div
                  class="tw-w-6 tw-h-6 tw-p-[2.22px] tw-justify-center tw-items-center tw-flex"
                >
                  <cohrex-svg
                    [name]="menu.icon"
                    [fill]="'tw-fill-white'"
                  ></cohrex-svg>
                </div>
                <div
                  class="tw-grow tw-shrink tw-basis-0  {{
                    !sideNavHidden ? 'tw-block' : 'tw-hidden'
                  }} {{ collapsed ? 'lg:tw-hidden' : 'lg:tw-block' }}"
                >
                  {{ menu.title | translate }}
                </div>
              </div>
              @if (!collapsed) {
                <span class="material-icons">keyboard_arrow_down</span>
              }
            </button>
            <div
              class="tw-bg-[#dcdada94] tw-rounded-t-none tw-transition-all tw-duration-500 tw-ease-in-out childrenMenu {{
                collapsed ? 'tw-rounded-b-none' : 'tw-rounded-lg'
              }}"
              [ngClass]="[
                isParentMenuActive(menu.children)
                  ? '!tw-visible !tw-h-fit'
                  : 'tw-hidden h-0'
              ]"
            >
              <div class="tw-py-2">
                @for (childMenu of menu.children; track childMenu) {
                  <a
                    [routerLink]="[childMenu.path]"
                    class="tw-flex tw-items-center tw-gap-3 tw-rounded-lg {{
                      collapsed ? 'tw-px-3 tw-mx-1' : 'tw-px-8 tw-mx-3'
                    }} tw-py-2"
                    routerLinkActive="!tw-bg-white"
                  >
                    <div class="tw-items-center tw-flex">
                      <cohrex-svg [name]="childMenu.icon"></cohrex-svg>
                    </div>
                    @if (!collapsed) {
                      <div class="tw-text-md">
                        {{ childMenu.title | translate }}
                      </div>
                    }
                  </a>
                }
              </div>
            </div>
          </div>
        }
      }
    }
  </div>
  <!-- options -->
  <div
    class="tw-self-stretch tw-h-[180px] tw-px-0 {{
      collapsed ? 'tw-px-0' : 'lg:tw-px-2'
    }} tw-pt-4 tw-pb-6 tw-flex-col tw-justify-end tw-items-center tw-gap-3 tw-flex"
  >
    <div
      class="tw-self-stretch tw-h-10 tw-px-2 {{
        collapsed ? 'tw-px-2' : 'lg:tw-px-2'
      }} tw-justify-start tw-items-center tw-gap-3 tw-inline-flex"
    >
      <img
        class="tw-w-10 tw-h-10 tw-relative tw-rounded-3xl"
        src="../../../../assets/logos/icon.png"
        alt="Avatar"
      />
      <div
        class="tw-flex-col tw-justify-center tw-items-start tw-gap-1 {{
          !sideNavHidden ? 'tw-block' : 'tw-hidden'
        }} {{ collapsed ? 'lg:tw-hidden' : 'lg:tw-inline-flex' }}"
      >
        <div class="tw-text-neutral-900 tw-font-medium">
          {{ user?.firstname }} {{ user?.lastname }}
        </div>
        <cohrex-pill color="success" [small]="true">{{
          user?.roles?.[0]?.name
        }}</cohrex-pill>
      </div>
    </div>
    <div
      class="tw-self-stretch tw-h-[82px] tw-flex-col tw-justify-center tw-items-start tw-gap-0.5 tw-flex"
    >
      <div
        class="tw-h-10 tw-px-3 tw-py-2 tw-rounded-lg tw-justify-start tw-items-center tw-gap-2 tw-inline-flex tw-cursor-pointer"
      >
        <div
          class="tw-w-6 tw-h-6 tw-px-0.5 tw-py-[2.57px] tw-justify-center tw-items-center tw-flex"
        >
          <cohrex-svg name="cog"></cohrex-svg>
        </div>
        <div
          class="tw-grow tw-shrink tw-basis-0 tw-text-neutral-800 {{
            !sideNavHidden ? 'tw-block' : 'tw-hidden'
          }} {{ collapsed ? 'lg:tw-hidden' : 'lg:tw-block' }}"
        >
          {{ 'sideNav.options' | translate }}
        </div>
      </div>
      <button
        class="tw-h-10 tw-px-3 tw-py-2 tw-rounded-lg tw-justify-start tw-items-center tw-gap-2 tw-inline-flex tw-cursor-pointer"
        (click)="handleLogout()"
      >
        <div
          class="tw-w-6 tw-h-6 tw-p-1 tw-justify-center tw-items-center tw-flex"
        >
          <cohrex-svg name="logout"></cohrex-svg>
        </div>
        <div
          class="tw-grow tw-shrink tw-basis-0 tw-text-red-700 {{
            !sideNavHidden ? 'tw-block' : 'tw-hidden'
          }} {{ collapsed ? 'lg:tw-hidden' : 'lg:tw-block' }}"
        >
          {{ 'sideNav.logout' | translate }}
        </div>
      </button>
    </div>
  </div>
</nav>
